import React, { useState, useMemo } from 'react';
import taskService from 'services/http/task-service';
import { SkeletonLoader, DropdownTemplate, CustomButton, WithLoadingComponent } from 'components/shared';
import utils, { CUSTOM_MESSAGES } from 'utils';

export const TaskDeffer = (props) => {
    const [selectedOption, setSelectedOption] = useState();
    const [loadingSubmission, setLoadingSubmission] = useState(false);
    const { data: deferRangeItems } = props;
    const options = deferRangeItems.map(item => { item['value'] = item.rangeDescription; return item; });

    const onSubmit = () => {
        if (selectedOption) {
            setLoadingSubmission(true);
            let range = options.filter(x => x.value === selectedOption)[0];
            delete range['value'];
            taskService.updatetaskStatus({
                taskId: props.task.id,
                status: props.task.status,
                view: props.view,
                payload: range
            }).then(response => {
                props.successCallback(response.message);
            }, error => {
                props.errorCallback(error);
            }).finally(() => {
                setLoadingSubmission(false);
            });
        } else {
            props.errorCallback(CUSTOM_MESSAGES.NO_ITEM_SELECTED);
        }
    }

    return (
        <>
            <div className="text-center mx-auto">
                <h6 className="mt-2">Select the defer delay</h6>
                <DropdownTemplate
                    options={options}
                    optionLabel="value"
                    placeholder="Range time"
                    className="sm-dropdown"
                    icon="bi bi-alarm"
                    width="fit-content"
                    rootClassName="mx-auto"
                    scrollHeight="100px"
                    selectedItem={selectedOption}
                    onItemChange={(e) => setSelectedOption(e.value)}
                />
            </div>
            <div className="my-4 text-center">
                <CustomButton
                    label={utils.labelTemplate(<><i className="bi bi-check-circle" /> Submit</>, loadingSubmission, "Processing...")}
                    style={{ width: "60%" }}
                    className={loadingSubmission && "not-allowed"}
                    onClick={(e) => { onSubmit(e) }} />
            </div>
        </>

    );
}

export const TaskDefferHoc = (props) => {
    let Hoc = useMemo(() => WithLoadingComponent(TaskDeffer, () => taskService.getDeferRangeTimeItems(), <SkeletonLoader factor={1} />)(props), []);
    return <Hoc />
}